var moment = require("moment-timezone"); moment.tz.add('Asia/Karachi|PKT|-50|0||24e6');